import { Trophy, AlertTriangle, TrendingUp, TrendingDown, Activity } from "lucide-react";
import { formatDelta, formatScore } from "@/lib/scoring";

const ICONS = {
  trophy: Trophy,
  "alert-triangle": AlertTriangle,
  "trending-up": TrendingUp,
  "trending-down": TrendingDown,
  activity: Activity,
};

const TONES = {
  positive: { ring: "ring-sage-500/20", accent: "text-sage-600", iconBg: "bg-sage-100" },
  warning: { ring: "ring-[#E07A5F]/20", accent: "text-[#E07A5F]", iconBg: "bg-[#FBEDE5]" },
  critical: { ring: "ring-[#E07A5F]/30", accent: "text-[#E07A5F]", iconBg: "bg-[#FBEDE5]" },
  neutral: { ring: "ring-sand-200", accent: "text-ink-900", iconBg: "bg-sand-100" },
};

export default function FindingsCards({ items = [] }) {
  if (!items.length) return null;
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3" data-testid="findings-cards">
      {items.map((f) => {
        const Icon = ICONS[f.icon] || Activity;
        const tone = TONES[f.tone] || TONES.neutral;
        const delta = formatDelta(f.delta);
        return (
          <div
            key={f.id}
            className={`tk-card !p-4 ring-1 ${tone.ring}`}
            data-testid={`finding-${f.id}`}
          >
            <div className={`h-9 w-9 rounded-2xl ${tone.iconBg} flex items-center justify-center ${tone.accent}`}>
              <Icon size={16} />
            </div>
            <p className="tk-label mt-3">{f.title}</p>
            <p className="font-outfit text-base text-ink-900 mt-1 leading-tight">{f.subtitle}</p>
            <div className="flex items-baseline gap-2 mt-1">
              <span className="font-outfit text-xl text-ink-900">{formatScore(f.value)}</span>
              {delta != null && (
                <span className={`font-dmsans text-xs ${f.delta > 0 ? "text-sage-600" : f.delta < 0 ? "text-[#E07A5F]" : "text-ink-600"}`}>
                  {delta}
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
